"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationReader = void 0;
var PaginationReader = /** @class */ (function () {
    function PaginationReader() {
    }
    PaginationReader.read = function (jsonResponse) {
        var _a, _b;
        return {
            page: (_a = jsonResponse.page) !== null && _a !== void 0 ? _a : 0,
            pageSize: (_b = jsonResponse.page_size) !== null && _b !== void 0 ? _b : 0,
            total: jsonResponse.total,
            cursor: jsonResponse.cursor,
        };
    };
    return PaginationReader;
}());
exports.PaginationReader = PaginationReader;
//# sourceMappingURL=PaginationReader.js.map